export { NGXS_CONCURRENCY_PLUGIN_OPTIONS, NgxsConcurrencyPlugin, NgxsConcurrencyPluginOptions } from "./ngxs-concurrency-plugin";
